<template>
  <div class="app-container">
    <div class="app-content">
      <div class="split-flex">
        <div class="flex-left">
          <el-form ref="form" :model="query">
            <el-form-item label="用户组搜索">
              <el-input v-model="query.name" placeholder="请输入用户组名" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">
                搜索
              </el-button>
              <el-button @click="onReset">
                重置
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="flex-right">
          <transition name="slide-fade">
            <component :is="currentPage"
                       ref="userComponent"
                       :params="q"
                       :route.sync="r"
                       :pid="p"
                       @setRPQ="setRPQ" />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import groupAdd from './user-group-add.vue';
import groupList from './user-group-list.vue';
import groupDetail from './user-group-detail.vue';

export default {
  name: 'PageGroupManagement',
  title: '页面-用户组管理',
  components: { groupAdd, groupList, groupDetail },
  data() {
    return {
      r: 'list', // 页面路由，r=
      p: undefined, // id路由，p=
      q: undefined, // query查询条件参数，不放入url
      query: {},
    };
  },
  computed: {
    currentPage() {
      return `group-${this.r || 'list'}`;
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.query': function (val) {
      if (val.r) {
        this.r = val.r;
      }
      if (val.p) {
        this.p = val.p;
      }
    },
  },
  created() {
    this.setRPQ({ r: this.$route.query.r, p: this.$route.query.p });
  },
  methods: {
    onSubmit() {
      this.setRPQ({ r: 'list', p: undefined });
      this.q = this.query;
      this.$nextTick(() => {
        this.$refs.userComponent.fetchData();
      });
    },
    onReset() {
      this.query = {};
      this.onSubmit();
    },
    setRPQ({ r, p, q }) {
      console.log(r, p, q);
      this.r = r;
      this.p = p;
      if (q) {
        this.q = q;
      }
      this.$router.replace({ query: Object.assign({}, this.$route.query, { r, p }) });
    },
  },
};
</script>
